import {
  BACKEND_URL_ADMIN,
  BACKEND_URL_STORE
} from '@constants/server.constant'
import axios from 'axios'

export interface ListBlogsParams {
  limit?: number
  offset?: number
  start_date?: string
}

export const listBlogs = async (params: ListBlogsParams) => {
  const { data } = await axios.get(`${BACKEND_URL_STORE}/blog`, {
    params
  })
  return data
}

export const getBlogByHandle = async (handle: string) => {
  const { data } = await axios.get(`${BACKEND_URL_STORE}/blog/${handle}`)
  return data
}

export const getBlogBySanityId = async (id: string) => {
  const { data } = await axios.get(
    `${BACKEND_URL_ADMIN}/blog-by-sanity-id/${id}`,
    {
      withCredentials: true
    }
  )
  return data
}
